import {Base64} from 'helpers';
import {NoteCategory} from 'types';

interface ServerNoteType {
  name: string;
  id: string;
}

export const noteType = (type: ServerNoteType): NoteCategory => ({
  id: type.id,
  name: Base64.decode(type.name)
});
